<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	//Helpers
	import { real_id, real_id_z } from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Text, Button, Input } from '@Shelly/shelly-design-system';
	import { postReq } from 'src/services/http';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	export let device;

	let id = real_id(device.id);

	let settings = readDeviceSettings(id)['Configuration:0'];
	const setting = 91;
	let idleTime = settings[setting];
	let cacheIdle = idleTime;
	let loading = false;

	const min = 1;
	const max = 32000; //65000 means unlimited wtf todo must finish this setting and texts

	$: errorMaxtimeClose =
		idleTime && (+idleTime < min || +idleTime > max)
			? $format('generic_out_of_range', {
					default: `Value out of range`,
				})
			: '';

	const validate = () => {
		if (+idleTime > max) {
			idleTime = max;
		}
		if (+idleTime < min) {
			idleTime = min;
		}
		return idleTime;
	};

	const setIdlePowerPeriod = async () => {
		if (cacheIdle === idleTime) return;
		validate();
		loading = true;

		const params = {
			id: real_id_z(device.id), //gateway's id
			a: 'call', //inclusion command
			cc: 'Configuration', //command class
			m: 'set', //method
			ep: 0, //endpoint
			params: JSON.stringify([{ parameter: setting, value: +idleTime }]), //parameters parameter - setting index, value - setting value
		};
		const res: SettingRequest = await postReq(`/fast/device/zw`, {
			...params,
		});

		if (res.isok) {
			params.m = 'get'; //override method
			params.params = JSON.stringify([+setting]); //override params
			const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});
		}
		await onSettingsResponse(res, device);
		cacheIdle = idleTime;
		loading = false;
	};

	// TODO: finish texts
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('movement_time_description', {
		values: { value: idleTime, min: min, max: max },
		default:
			'When the shutter is not calibrated (or the motor is not equipped with a limit switch), this parameter defines the movement time of the motor.',
	})}
</Text>

<Input
	aria-label={$format('input_movement_time', {
		default: 'Enter the movement time.',
	})}
	class="mb-s"
	size="m"
	bind:value={idleTime}
	type={'number'}
	{min}
	{max}
	error={errorMaxtimeClose}
	info={$format('movement_time_description_values_description', {
		values: { value: idleTime, min: min, max: max },
		default: ' 1 - 32000 in milliseconds', //looks like they are milliseconds
		/**
         * Default value: 120

            Values & descriptions:

            value = 1 - 32000s this description is wrong
        */
	})}
	step={1}
	on:enter={() => {
		idleTime = validate();
	}}
	on:enter={setIdlePowerPeriod}
	id="input-n7gmnop"
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setIdlePowerPeriod}
	>{$format('button_save')}</Button
>
